import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Theme,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReactNode, useState } from "react";
import shiPalette from "shared-ui/src/theme/shiPalette";
import darkPalette from "shared-ui/src/theme/darkPalette";
import { Indentation } from "./rowTypes";

type SubtableRowProps = Indentation & {
  title: string;
  children: ReactNode;
  colSpan?: number;
};

export function SubtableRow({
  title,
  xWidth,
  xGap,
  children,
  colSpan = 6,
}: Readonly<SubtableRowProps>) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpanded = () => {
    setIsExpanded((current) => !current);
  };

  return (
    <TableRow
      sx={{
        "& > td": {
          borderBottom: 0,
        },
      }}
    >
      <TableCell
        colSpan={colSpan}
        sx={(theme) => ({
          px: 2,
          pt: 0,
          pb: 2,
          pl: `calc(${theme.spacing(2)} + ${xWidth}px + ${theme.spacing(xGap)})`,
        })}
      >
        <Box
          sx={{
            px: 2.5,
            py: 0.75,
          }}
        >
          <Box
            sx={{
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: (theme: Theme) =>
                theme.palette.mode === "dark"
                  ? darkPalette.background.default
                  : shiPalette.background.default,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              {title}
            </Typography>
            <IconButton
              onClick={handleToggleExpanded}
              size="small"
              aria-label={isExpanded ? `Collapse ${title}` : `Expand ${title}`}
              aria-expanded={isExpanded}
            >
              {isExpanded ? (
                <KeyboardArrowUpIcon fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" />
              )}
            </IconButton>
          </Box>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box sx={{ pt: 1.5, display: "grid", gap: 1.25 }}>{children}</Box>
          </Collapse>
        </Box>
      </TableCell>
    </TableRow>
  );
}
